import { render } from "./MButton.vue?vue&type=template&id=0c28f6bb&scoped=true"
import script from "./MButton.vue?vue&type=script&lang=js"
export * from "./MButton.vue?vue&type=script&lang=js"

import "./MButton.vue?vue&type=style&index=0&id=0c28f6bb&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c28f6bb"]])

export default __exports__